import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home';
import MainHome from '@/views/MainHome';
import ProxyRouter from '@/views/ProxyRouter';

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: '',
    routes:[
        {
            path: '/:proj/:lang',
            name: 'Home',
            component: Home
        },
        {
            path: '/:proj/:lang/:pagetitle',
            name: 'ProxyRouter',
            component: ProxyRouter
        }
    ]
})

//router.afterEach((to, from, next) => {
router.afterEach(() => {
    Vue.nextTick(() => {
        if ( router.history.current.params.proj=='dwdv') {
            document.title = 'DeLand West to Dona Vista Transmission Line Project';
        } else if ( router.history.current.params.proj=='sparr') {
            document.title = 'Sparr Substation & Transmission Line Project';
        }
        else{
            document.title = 'Duke';
        }
           
    });
})

export default router